export default "__VITE_ASSET__7EvC6gge__"